module.exports = __webpack_public_path__ + "img/fund-step5-en.c000e11e.png";